import { Component, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
export var /** @type {?} */ LY_CHECKBOX_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return LyCheckbox; }),
    multi: true
};
export var CheckboxState = {};
CheckboxState.Init = 0;
CheckboxState.Checked = 1;
CheckboxState.Unchecked = 2;
CheckboxState.Indeterminate = 3;
CheckboxState[CheckboxState.Init] = "Init";
CheckboxState[CheckboxState.Checked] = "Checked";
CheckboxState[CheckboxState.Unchecked] = "Unchecked";
CheckboxState[CheckboxState.Indeterminate] = "Indeterminate";
;
var LyCheckbox = (function () {
    function LyCheckbox() {
        this.onTouched = function () { };
        this._currentCheckState = CheckboxState.Init;
        this.checked = false;
        this.change = new EventEmitter();
        this.indeterminateChange = new EventEmitter();
        this._controlValueAccessorChangeFn = function (value) { };
    }
    /**
     * Toggles the `checked` state of the checkbox.
     * @return {?}
     */
    LyCheckbox.prototype.toggle = function () {
        this.checked = !this.checked;
    };
    /**
     * @param {?} event
     * @return {?}
     */
    LyCheckbox.prototype._onChangeEvent = function (event) {
        event.stopPropagation();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    LyCheckbox.prototype._onInputClick = function (event) {
        var /** @type {?} */ ev = (event.target);
        this.checked = ev.checked;
        this._controlValueAccessorChangeFn(this.checked);
        console.log('_onInputClick', ev.checked);
    };
    /**
     * @param {?} value
     * @return {?}
     */
    LyCheckbox.prototype.writeValue = function (value) {
        this.checked = !!value;
        console.log('value', this.checked);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    LyCheckbox.prototype.registerOnChange = function (fn) {
        this._controlValueAccessorChangeFn = fn;
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    LyCheckbox.prototype.ngOnChanges = function (changes) {
        console.log('changes', changes);
        if (changes['src']) {
            // fn
        }
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    LyCheckbox.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    /**
     * @return {?}
     */
    LyCheckbox.prototype.ngOnInit = function () {
    };
    /**
     * @return {?}
     */
    LyCheckbox.prototype.ngAfterContentInit = function () {
    };
    /**
     * @return {?}
     */
    LyCheckbox.prototype.ngOnDestroy = function () {
    };
    return LyCheckbox;
}());
export { LyCheckbox };
LyCheckbox.decorators = [
    { type: Component, args: [{
                selector: 'ly-checkbox',
                template: "<label> <div class=\"ly-checkbox-container\"> <input #input [hidden]=\"false\" type=\"checkbox\" [id]=\"id\" [required]=\"required\" [checked]=\"checked\" [value]=\"value\" [disabled]=\"disabled\" [name]=\"name\" [indeterminate]=\"indeterminate\" [attr.aria-label]=\"ariaLabel\" [attr.aria-labelledby]=\"ariaLabelledby\" (change)=\"_onChangeEvent($event)\" (click)=\"_onInputClick($event)\"> </div> </label> ",
                styles: [":host { display: inline-block; } "],
                providers: [LY_CHECKBOX_CONTROL_VALUE_ACCESSOR]
            },] },
];
/**
 * @nocollapse
 */
LyCheckbox.ctorParameters = function () { return []; };
LyCheckbox.propDecorators = {
    'id': [{ type: Input, args: ['id',] },],
    'ariaLabel': [{ type: Input, args: ['attr.aria-label',] },],
    'ariaLabelledby': [{ type: Input, args: ['attr.aria-labelledby',] },],
    'required': [{ type: Input, args: ['required',] },],
    'labelPosition': [{ type: Input, args: ['labelPosition',] },],
    'color': [{ type: Input, args: ['color',] },],
    'value': [{ type: Input, args: ['value',] },],
    'name': [{ type: Input, args: ['name',] },],
    'disabled': [{ type: Input, args: ['disabled',] },],
    'checked': [{ type: Input, args: ['checked',] },],
    'indeterminate': [{ type: Input, args: ['indeterminate',] },],
    'change': [{ type: Output, args: ['change',] },],
    'indeterminateChange': [{ type: Output, args: ['indeterminateChange',] },],
};
function LyCheckbox_tsickle_Closure_declarations() {
    /** @type {?} */
    LyCheckbox.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    LyCheckbox.ctorParameters;
    /** @type {?} */
    LyCheckbox.propDecorators;
    /** @type {?} */
    LyCheckbox.prototype.onTouched;
    /** @type {?} */
    LyCheckbox.prototype._currentCheckState;
    /** @type {?} */
    LyCheckbox.prototype.id;
    /** @type {?} */
    LyCheckbox.prototype.ariaLabel;
    /** @type {?} */
    LyCheckbox.prototype.ariaLabelledby;
    /** @type {?} */
    LyCheckbox.prototype.required;
    /** @type {?} */
    LyCheckbox.prototype.labelPosition;
    /** @type {?} */
    LyCheckbox.prototype.color;
    /** @type {?} */
    LyCheckbox.prototype.value;
    /** @type {?} */
    LyCheckbox.prototype.name;
    /** @type {?} */
    LyCheckbox.prototype.disabled;
    /** @type {?} */
    LyCheckbox.prototype.checked;
    /** @type {?} */
    LyCheckbox.prototype.indeterminate;
    /** @type {?} */
    LyCheckbox.prototype.change;
    /** @type {?} */
    LyCheckbox.prototype.indeterminateChange;
    /** @type {?} */
    LyCheckbox.prototype._controlValueAccessorChangeFn;
}



//////////////////
// WEBPACK FOOTER
// ./src/app/alyle-ui-profile/checkbox/ly-checkbox/ly-checkbox.component.js
// module id = 692
// module chunks = 31